import axios from "axios";

export async function apiCaller(api, Data = "") {

    let resData = "";
    if(Data != "") {
        resData = await axios.post(
            api,
            {createdAndUpdatedData: Data},
            { withCredentials: true }
          );
    } else {
        resData = await axios.post(
            api,
            {},
            { withCredentials: true }
          );
    }
    

      return resData;
}